import React, { memo } from "react";
import Modal from "../../shared/Modal";
import { prefix } from "../../../../i18n";

const tCoPayment = prefix("co-payment");

const CoPaymentModal = memo(
  ({
    paymentDefinitions,
    show,
    close,
    conditionsAccepted,
    handleAcceptConditions,
  }) => {
    return (
      <Modal show={show} untoggle={close} large>
        <div className="gl2026-modal__header">
          <h4 className="gl2026-modal__title">{tCoPayment("conditions.title")}</h4>
        </div>
        <div className="gl2026-modal__body">
          <div
            className="gl2026-modal__terms custom-inner-html"
            dangerouslySetInnerHTML={{
              __html: paymentDefinitions.general_terms_and_coditions,
            }}
          />
        </div>
        <div className="gl2026-modal__footer">
          <div className="gl2026-modal__checkbox-row">
            <input
              type="checkbox"
              id="co-payment-accept"
              checked={conditionsAccepted}
              onChange={handleAcceptConditions}
            />
            <label htmlFor="co-payment-accept">Aceitar</label>
          </div>
        </div>
      </Modal>
    );
  },
);

export default CoPaymentModal;
